document.addEventListener('click', function (event) {
  const bandBtn = event.target.closest('.jf-band-btn');
  if (bandBtn) {
    const group = bandBtn.closest('.jf-band-options');
    group.querySelectorAll('.jf-band-btn').forEach((btn) => {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-checked', 'false');
    });
    bandBtn.classList.add('is-active');
    bandBtn.setAttribute('aria-checked', 'true');

    const form = bandBtn.closest('.jf-valuation__form');
    const input = form && form.querySelector('[data-jf-band-value]');
    if (input) input.value = bandBtn.textContent.trim();

    const bandGroup = form && form.querySelector('[data-jf-band-group]');
    if (bandGroup) bandGroup.classList.remove('is-invalid');
    group.removeAttribute('aria-invalid');
    return;
  }
});

document.addEventListener('submit', function (event) {
  const form = event.target.closest('.jf-valuation__form');
  if (!form) return;

  const bandInput = form.querySelector('[data-jf-band-value]');
  if (!bandInput || bandInput.dataset.required !== 'true' || bandInput.value) return;

  event.preventDefault();

  const bandGroup = form.querySelector('[data-jf-band-group]');
  const bandOptions = form.querySelector('.jf-band-options');
  if (bandGroup) bandGroup.classList.add('is-invalid');
  if (bandOptions) {
    bandOptions.setAttribute('aria-invalid', 'true');
    const firstBand = bandOptions.querySelector('.jf-band-btn');
    if (firstBand) firstBand.focus();
  }
});
